import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isLanding = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goToSignup = () => {
    const el = document.getElementById("signup");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#F7F5F2]/85 backdrop-blur-xl border-b border-[#E5E0D8]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-center gap-3 group"
        >
          <BrandMark />
        </Link>

        {isLanding ? (
          <nav className="hidden md:flex items-center gap-8 text-sm text-[#1A1A1A] font-body">
            <a data-testid="nav-philosophy" href="#philosophy" className="hover:text-[#1FA5B8] transition-colors">
              The Signs
            </a>
            <a data-testid="nav-process" href="#process" className="hover:text-[#1FA5B8] transition-colors">
              Awakening
            </a>
            <a data-testid="nav-reflection" href="#reflection" className="hover:text-[#1FA5B8] transition-colors">
              The Doorway
            </a>
            <a data-testid="nav-faq" href="#faq" className="hover:text-[#1FA5B8] transition-colors">
              FAQ
            </a>
          </nav>
        ) : (
          <nav className="hidden md:flex items-center gap-8 text-sm text-[#1A1A1A] font-body">
            <Link to="/" data-testid="nav-home" className="hover:text-[#1FA5B8] transition-colors">
              The Academy
            </Link>
            <Link to="/the-deeper-reactivation" data-testid="nav-deeper" className="hover:text-[#1FA5B8] transition-colors">
              The Deeper Reactivation
            </Link>
            <Link to="/work-with-me" data-testid="nav-work" className="hover:text-[#1FA5B8] transition-colors">
              Work with me
            </Link>
            <Link to="/born-to-create" data-testid="nav-podcast" className="hover:text-[#1FA5B8] transition-colors">
              Podcast
            </Link>
            <Link to="/wynn" data-testid="nav-wynn" className="hover:text-[#1FA5B8] transition-colors">
              WYNN
            </Link>
          </nav>
        )}

        {isLanding ? (
          <Button
            data-testid="header-cta-button"
            onClick={goToSignup}
            className="rounded-none bg-[#1FA5B8] hover:bg-[#178391] text-[#F7F5F2] font-body text-[12px] uppercase tracking-[0.18em] h-10 px-5"
          >
            Begin gently
          </Button>
        ) : (
          <Link
            to="/"
            data-testid="header-cta-button"
            className="rounded-none bg-[#1FA5B8] hover:bg-[#178391] text-[#F7F5F2] font-body text-[12px] uppercase tracking-[0.18em] h-10 px-5 inline-flex items-center"
          >
            Get the Reset
          </Link>
        )}
      </div>
    </header>
  );
}

export function BrandMark({ size = "sm" }) {
  // sm for navbar, lg for hero/footer
  const isLg = size === "lg";
  const heightClass = isLg ? "h-24 md:h-28" : "h-12 md:h-14";

  return (
    <img
      src="https://customer-assets.emergentagent.com/job_five-min-formula/artifacts/wmey5e1w_Untitled%20design.png"
      alt="Awakened Artist Academy"
      className={`${heightClass} w-auto select-none`}
      draggable="false"
    />
  );
}
